export const fmtUK = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB") : "—");

export const ITEM_STATUS = {
  current: { label: "Current", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  no_expiry: { label: "No Expiry", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  expiring: { label: "Expiring soon", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  insufficient: { label: "Below required validity", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  expired: { label: "Expired", cls: "bg-red-100 text-red-700 border-red-300" },
  missing: { label: "Missing", cls: "bg-red-100 text-red-700 border-red-300" },
};

export const OVERALL = {
  compliant: { label: "Compliant", cls: "bg-emerald-600 text-white" },
  warning: { label: "Attention", cls: "bg-amber-500 text-white" },
  non_compliant: { label: "Not compliant", cls: "bg-red-600 text-white" },
};

// Human expiry line, per the agreed formats.
export function describeExpiry(it) {
  if (!it) return "—";
  if (it.status === "missing") return "Missing";
  if (it.status === "no_expiry") return "No Expiry";
  if (it.status === "expired") return `Expired ${fmtUK(it.expiry_date)}`;
  if (it.expiry_date) {
    const days = it.days_remaining;
    return `Expires ${fmtUK(it.expiry_date)}${days != null ? ` — ${days} day${days === 1 ? "" : "s"} remaining` : ""}`;
  }
  return "—";
}
